import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import JBImage from 'components/essentials/JBImage';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import Link from 'components/consumer/Link';
import ToggleCTALinkButton from 'components/essentials/ToggleCTALinkButton';
import ToggleCTAImageLink from './ToggleCTAImageLink';

const HalfImage = ({ imageProps }) => (
  <JBImage
    src={imageProps.src}
    alt={imageProps.alt}
    className="half-image"
    crop="focalpoint"
    fpY={0.7}
    sizes="(max-width: 767px) 100vw, 50vw"
  />
);

HalfImage.propTypes = {
  imageProps: PropTypes.shape({
    alt: PropTypes.string.isRequired,
    src: PropTypes.string,
  }).isRequired,
};

const LinkHalfImage = ({ to, imageProps }) => (
  <Link to={to}>
    <HalfImage imageProps={imageProps} />
  </Link>
);

LinkHalfImage.propTypes = {
  to: PropTypes.string.isRequired,
  imageProps: PropTypes.shape({
    alt: PropTypes.string,
    src: PropTypes.string.isRequired,
  }).isRequired,
};

const HalfImageHalfText = ({
  config: { imageProps, heading, subText, toggleInputType, imageOrientation },
}) => {
  let finalOrientation = 'default';
  if (imageOrientation && imageOrientation.value) {
    finalOrientation =
      imageOrientation.value !== 'Image Left' ? 'alt' : 'default';
  }
  const HeaderTag = heading.tagName || 'div';

  return (
    <FixedWidthContainer
      className={classNames('flex [&_a:hover]:underline', {
        'flex-row max-[767px]:flex-col': finalOrientation === 'default',
        'flex-row-reverse max-[767px]:flex-col': finalOrientation === 'alt',
      })}
    >
      <div
        className={classNames({
          'md:mr-16': finalOrientation === 'default',
          'md:ml-16': finalOrientation === 'alt',
        })}
      >
        <ToggleCTAImageLink
          toggleInputType={toggleInputType}
          imageProps={imageProps}
        />
      </div>

      <div
        className={classNames(
          'w-1/2 max-[767px]:w-full [&_img]:w-full [&_img]:align-middle [&_img]:[transition:all_.25s_ease-in-out] flex flex-row !m-0',
          {
            'max-[767px]:pt-6':
              finalOrientation === 'default' || finalOrientation === 'alt',
          }
        )}
      >
        <div className="w-full flex flex-col content-center justify-center font-sans max-[767px]:w-full">
          <HeaderTag
            className="text-2xl font-bold text-gray"
            dangerouslySetInnerHTML={{ __html: heading.content }}
          />
          <div
            className="text-base text-gray mx-0 my-6"
            dangerouslySetInnerHTML={{ __html: subText.content }}
          />
          {!!toggleInputType && (
            <ToggleCTALinkButton
              toggleInputType={toggleInputType}
              heading={heading}
            />
          )}
        </div>
      </div>
    </FixedWidthContainer>
  );
};

HalfImageHalfText.propTypes = {
  config: PropTypes.shape({
    cta: PropTypes.shape({
      content: PropTypes.string,
      linkTo: PropTypes.string,
    }),
    heading: PropTypes.shape({
      content: PropTypes.string,
      tagName: PropTypes.string,
    }),
    imageOrientation: PropTypes.shape({
      value: PropTypes.string,
    }),
    imageProps: PropTypes.shape({
      alt: PropTypes.string,
      src: PropTypes.string,
    }),
    subText: PropTypes.shape({
      content: PropTypes.string,
    }),
    toggleInputType: PropTypes.shape({
      ctaLink: PropTypes.shape({
        linkTo: PropTypes.string,
      }),
      inputType: PropTypes.string,
    }),
  }),
};

const HalfImageHalfTextUI = props => {
  if (props?.config?.elementAttribute?.id) {
    return (
      <div id={props?.config?.elementAttribute?.id}>
        <HalfImageHalfText {...props} />
      </div>
    );
  }
  return <HalfImageHalfText {...props} />;
};

HalfImageHalfTextUI.propTypes = {
  config: PropTypes.shape({
    elementAttribute: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
};

export default HalfImageHalfTextUI;
